<template>
	<div class="pranetarea">

		<div class="pranet_title Flexalign" 
		@click="parentclick"
		v-show="!isEdit && currentTitle">
			<i class="iconfont icon-bingji"></i>
			<div class="txt" >
				{{currentTitle || ''}} 
			</div>
		</div>
		 
		<div class="search_create_box" v-show="isEdit">
			
			<div class="search_input Flexalign">
				<!-- :disabled="current_id != ''" -->
				<el-input v-model="current_name"  placeholder="可输入标题"
				@focus="searchFocus"
				@blur="searchBlur" 
				@input="search_change"></el-input>
				<div class="dropdown" :class="{'isdown': isdown}">
					<i class="el-icon-arrow-down"></i>
				</div>
			</div>
			
			
			<div class="search_resbox" v-show="isdown">
				<div class="res_item FlexBetween" 
				@click="setSearchVal(dval)"
				:class="{'isActive': dval.isActive}" 
				v-for="(dval, dindex) in downlist">
					<div class="Flexalign">
						<div class="code" v-if="dval.code_txt">
							{{dval.code_txt || ''}}
						</div>
						<div class="title Singlerow">
							{{dval.title || ''}}
						</div>
					</div>
					
					<div class="type_txt">
						{{dval.type_txt || ''}}
					</div>
				</div>
				<div class="nodatxt" v-if="downlist.length == 0">
					暂无数据
				</div>
				
			</div>
		</div>
		
		
	</div>
</template>

<script>
	var that;
	import {
		fn_retjson,
		retJSONArr,
	} from "network/defaults";
	import {
		
		get_project_demand_code,
		get_project_damand_status,
		get_project_damand_level,
		add_project_damand,
		get_project_damand_list,
		del_project_damand,
		get_project_damand_details,
		update_project_damand,
		get_project_damand_son,
		update_project_damand_field,
		updata_project_field,
	} from "../../js/project.js";
	export default {
		name:'parentarea',
		props: {
			parentinfo: {
				type: Object | String,
				default: ()=>{
					return {}
				}
			},
			types: {  // 1.需求 2.任務  3.问题
				type: String,
				default: '1',
			},
			
			content_id: {  // 当前详情的id
				type: Number | String,
				default: 0,
			},
			isfather: {  // 
				type: Boolean,
				default: false,
			},
			
		},
		components: {
			
		},
		watch: {
			parentinfo(){
				this.setDatas()
			},
			isEdit(){
				console.log(this.currentparent,'currentparent')
			},
		},
		created(){
			this.setDatas()
		},
		methods: {
			parentclick(){
				let obj = this.currentparent
				if(!obj) return;
				let {
					project_demand_id, type
				} = obj
				console.log(project_demand_id,'obj')
				let path = ''
				if(type == 1) {  // 需求
					path = `/project/demandlist`
				}
				else if(type == 2) {  // 任务
					path = `/project/tasklist`
				}
				else if(type == 3) {  // 问题
					path = `/project/troublelist`
				}
				// this.$router.resolve({
				// 	path,
				// 	query: {
				// 		isDetail: true,
				// 		project_demand_id,
				// 	},
				// });
				
				let pathHerf = this.$router.resolve({
					path, // 你自己要跳转的路径
					query:{
				        isDetail: true,
				        project_demand_id,
				    }
				})
				// , '_blank'
				window.open(pathHerf.href);
			},
			setDatas(){
				if(this.types) {
					this.curRote = this.types.split(',')
				}
				this.currentparent = fn_retjson(this.parentinfo)
				
				if(this.currentparent && this.currentparent.project_demand_pid_result) {
					let obj = this.currentparent.project_demand_pid_result
					this.current_name = obj.title 
					this.currentTitle = fn_retjson(obj.title)
					this.current_id = obj.project_demand_id 
				}
				
			},
			  
			searchFocus(e){
				clearTimeout(this.TimeId);
				this.TimeId = setTimeout(() => {
					this.getsubclass(); // 定时器生效时执行的方法
				}, 500);
			},
			searchBlur(e){
				clearTimeout(this.TimeId);
				this.TimeId = setTimeout(() => {
					this.isdown = false
					this.isEdit = false
					if(!this.current_id) {
						this.$emit('update:isfather')
					}
				}, 500)
			},
			search_change(e){
				clearTimeout(this.TimeId);
				this.TimeId = setTimeout(() => {
					this.getsubclass(e); // 定时器生效时执行的方法
				}, 500);
			},
			setSearchVal(dval){
				if(dval) {
					let content_id = dval.project_demand_id || 0
					let resdata = {
						content_name: dval.title,
						content_id,
					}
					
					let fd = new FormData();
					fd.append('project_demand_id', this.content_id);
					fd.append('field', 'project_demand_pid');
					fd.append('value', content_id);
					
					let txt = this.typelist[dval.type - 1]
					let edit_data = []
					let newEle = {
						field: `父级工作项`, // 字段名称
						before: this.currentTitle,  //修改前
						after: dval.title, //修改后
					}
					edit_data.push(newEle)
					fd.append('edit_data', JSON.stringify(edit_data));
					update_project_damand_field(fd).then((res)=>{
						if (this.$handlereq(res)) {
							this.$alertMess('更新成功')
							this.currentTitle = ''
							this.current_name = ''
							this.current_id = ''
							this.$emit('update')
						}
					})
				}
			},
			
			getsubclass(search_name){
				console.log(this.curRote,'curRote')
				if(this.curRote.length == 0) return;
				if(!this.$clickgate()) return;
				this.downlist = [
					{
						id: 0,
						title: '无父工作项'
					}
				]
				
				for(let item of this.curRote) {
					let data = {
						sort_type: 1, 
						pagesize: 99, 
						page: 1,
						type: item * 1,
						class_type: 0,
						search_type: 1,
					};
					if (search_name) {
						data.search_name = (search_name + '').trim();
					}
					this.getdatasList(data)
				}
			},
			
			// 获取 shuju
			getdatasList(data) {
				console.log(data,'data')
				get_project_damand_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || []
						for(let item of obj) {
							item.isActive = false
							item.id == item.project_demand_id || ''
							if(item.project_demand_id == this.current_id) {
								item.isActive = true
							}
							item.type_txt = this.typelist[item.type - 1]
							item.code_txt = item.project_demand_code || ''
						}
						let arr = []
						
						// 不等于自己  父级不等于自己  不是自己的父级
						arr = obj.filter(v=>v.project_demand_id != this.content_id && v.project_demand_pid != this.content_id && v.project_demand_id != this.currentparent.project_demand_pid)
						
						
						this.downlist = this.downlist.concat(arr)
						this.isdown = true
					}
				});
			},
			
			
		},
		data() {
			return {
				typelist: [
					'需求','任务','问题',
				],
				
				currentTitle: '',
				currentparent: '',
				
				current_name: '',
				current_id: '',
				isdown: false,
				downlist: [],
				
				TimeId: null,
				
				curRote: [],
				
				isEdit: false,
				
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../css/projecticon.css";
	
	.pranet_title {
		cursor: pointer;
		margin-bottom: 7px;
	
		i {
			color: rgba(144, 154, 170, 1);
			font-size: 12px;
			margin-right: 6px;
		}
	
		.txt {
			font-size: 13px;
			font-weight: 400;
			color: rgba(144, 154, 170, 1);
		}
	}
	
	.search_create_box{
		position: relative;
		width: 440px;
		margin-bottom: 5px;
		.search_input{
			position: relative;
			width: 100%;
			/deep/ .el-input{
				width: 100%;
				
			}
			i{
				
				font-size: 14px;
			}
			.dclearable:hover{
				i{
					color: red;
				}
			}
			.dclearable{
				cursor: pointer;
				right: 40px;
				position: absolute;
				z-index: 20000;
			}
			.dropdown.isdown{
				transform: rotate(180deg);
			}
			.dropdown{
				transition: all .3s;
				right: 15px;
				position: absolute;
			}
		}
		.search_resbox{
			position: absolute;
			top: 105%;
			left: 0;
			width: 100%;
			z-index: 10;
			
			max-height: 230px;
			overflow: auto;
			background-color: #fff;
			box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 15px;
			// box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
			.nodatxt{
				font-size: 14px;
				padding: 10px;
				text-align: center;
			}
			.res_item:hover{
				// background-color:rgb(245,246,248);
				background-color: #eee;
			}
			.res_item.isActive{
				background: #E9F2FE;
				.title{
					color: var(--themeColors);
				}
			}
			.res_item{
				padding: 10px;
				cursor: pointer;
				.code{
					font-size: 10px;
					padding: 5px;
					border-radius: 3px;
					background: rgba(245, 246, 248, 1);
					margin-right: 10px;
				}
				.title{
					color: rgba(46, 64, 94, 1);
					font-size: 12px;
					max-width: 300px;
				}
				.type_txt{
					font-size: 11px;
					color:#909090;
				}
				
			}
		}
	}
			
</style>